var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95948 1.44434C3.56998 1.44434 1.63281 3.32548 1.63281 5.64588C1.63281 9.84743 6.74615 13.667 9.49948 14.5554C12.2528 13.667 17.3661 9.84743 17.3661 5.64588C17.3661 3.32548 15.429 1.44434 13.0395 1.44434C11.5763 1.44434 10.2822 2.14981 9.49948 3.22961C9.10051 2.67776 8.57049 2.22739 7.95428 1.91662C7.33808 1.60586 6.65383 1.44386 5.95948 1.44434Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d64b5d31774726bd3723c0ca574ea2bf.svg";
export { ForwardRef as ReactComponent };